import React, { useEffect } from "react";
import { getServiceById } from "../../data/services";

import CTASection from "../../components/common/CTASection";
import ServiceSection from "./ServiceSection";

const ManagedITServices = () => {
  const service = getServiceById("managed-it");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="bg-gradient-to-b from-white to-light-blue min-h-screen">
            <h2 style={{ textAlign: "center", fontSize: "2rem", fontWeight: "bold", marginBottom: "1.5rem", color: "#001f3f"}}>
        DG FutureTechが提供するITサービス
      </h2>

        <ServiceSection />
        
        <CTASection
          title="ストレスフリーなITを実現します。? "
          description="DG FutureTech は、プロアクティブな監視やネットワーク サポートからオンデマンドの IT 支援まで、システムがスムーズに稼働することを保証します。そのため、お客様は安心してビジネスの成長に集中できます。"
        />
      </div>
    </>
  );
};

export default ManagedITServices;